import {
  Checkbox,
  Inline,
  Link,
  Typography,
} from '@omnipresentgroup/design-system';

const CHECKBOX_ID = 'bonus-disclaimer-checkbox';
const DETAILS_LINK =
  'https://help.omnipresent.com/en/articles/10760049-representation-on-bonus-payments-authorised';

export const BonusDisclaimerCheckbox = ({
  disclaimerAccepted,
  setDisclaimerAccepted,
}: {
  disclaimerAccepted: boolean;
  setDisclaimerAccepted: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  return (
    <Inline gap="4">
      <Checkbox
        id={CHECKBOX_ID}
        checked={disclaimerAccepted}
        onCheckedChange={() =>
          setDisclaimerAccepted(
            (previousDisclaimerAccepted) => !previousDisclaimerAccepted,
          )
        }
      />
      <Typography as="label" size="14" htmlFor={CHECKBOX_ID}>
        By checking this box, you agree and acknowledge the Representation on
        Bonus Payments{' '}
        <Link size="14" target="_blank" to={DETAILS_LINK}>
          detailed here
        </Link>
        .
      </Typography>
    </Inline>
  );
};
